
const VocabGreetings = {
    'good_morning' : ['Buen día', 'Good morning'],
    'good_afternoon': ['Buenas tardes', 'Good afternoon'],
    'good_night': ['Buenas noches', 'Good night'],
  }
  export default VocabGreetings;
    